import React from 'react';
import { FaGift, FaSave, FaEye, FaSpinner } from 'react-icons/fa';

const SealStep = ({ theme, isLocked, uploadActive, onSaveDraft, onPreviewGift, onSealGift }) => (
  <section id="gift-builder-seal" className="scroll-mt-6 lumirae-editor-panel p-5">
    <div className="text-[10px] font-black uppercase tracking-[0.28em]" style={{ color: theme.accent }}>
      Step 5 / Publish
    </div>
    <h3 className="mt-2 text-xl font-black uppercase tracking-tight" style={{ color: theme.text }}>
      Draft saves edits. Seal Gift publishes.
    </h3>
    <p className="mt-2 text-xs font-medium leading-relaxed opacity-60">
      Back only changes editor pages. Use Save Draft here to store the latest edits in the cloud.
    </p>
    <div className="mt-4 grid grid-cols-3 gap-2">
      {[
        { label: 'Draft', icon: FaSave, detail: 'Save edits' },
        { label: 'Preview', icon: FaEye, detail: 'Check flow' },
        { label: isLocked ? 'Reseal' : 'Seal', icon: FaGift, detail: uploadActive ? 'Wait upload' : 'Publish' },
      ].map((item) => {
        const Icon = item.icon;
        return (
          <div key={item.label} className="rounded-[1.1rem] border bg-white/60 p-3 text-center" style={{ borderColor: 'var(--lumirae-border-default)' }}>
            <Icon className="mx-auto mb-2" style={{ color: theme.accent }} />
            <div className="text-[9px] font-black uppercase tracking-widest" style={{ color: theme.text }}>
              {item.label}
            </div>
            <div className="mt-1 text-[8px] font-bold uppercase tracking-widest opacity-45">
              {item.detail}
            </div>
          </div>
        );
      })}
    </div>
    <div className="mt-4 grid gap-3">
      <button
        type="button"
        className="lumirae-ds-button lumirae-ds-button-secondary flex items-center justify-center gap-2 px-4"
        onClick={onSaveDraft}
        disabled={uploadActive}
      >
        {uploadActive ? <FaSpinner className="animate-spin" /> : <FaSave />}
        {uploadActive ? 'Wait for Upload' : 'Save Draft'}
      </button>
      <button
        type="button"
        className="lumirae-ds-button lumirae-ds-button-secondary flex items-center justify-center gap-2 px-4"
        onClick={onPreviewGift}
        disabled={uploadActive}
      >
        <FaEye /> Preview
      </button>
      <button
        type="button"
        className="lumirae-ds-button lumirae-ds-button-primary flex items-center justify-center gap-2 px-4"
        onClick={onSealGift}
        disabled={uploadActive}
      >
        <FaGift /> {isLocked ? 'Reseal Gift' : 'Seal Gift'}
      </button>
    </div>
  </section>
);

export default SealStep;
